// extracted by mini-css-extract-plugin
export default {"main":"Blogs_main__wqpUQ","box":"Blogs_box__QQe4j","imgCont":"Blogs_imgCont__SNfzK","content":"Blogs_content__J1LVE"};